<script setup lang="ts">
import type { RelatedArticle } from '~/types/Article'

type TransformedRelatedArticle = Pick<RelatedArticle, 'id' | 'slug' | 'title'>

interface Props {
  articles: TransformedRelatedArticle[] | null
  title: string
}

const localePath = useLocalePath()

const props = withDefaults(defineProps<Props>(), {})
</script>

<template>

  <div v-if="articles && articles.length > 0" class="not-prose">
    <hr class="my-8 md:my-16 border-t border-gray-200 dark:border-gray-700" />
    <h3 class="text-2xl font-medium mb-4">{{ props.title }}</h3>
    <div class="space-y-1">
      <NuxtLink
        v-for="article in articles"
        :key="article.slug"
        :to="localePath(`/articles/${article.slug}`)"
        class="group flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-all duration-500"
      >
        <div class="flex-1 flex items-center">
          <h3
            class="text-base font-medium group-hover:text-primary-500 transition-colors duration-500 my-0"
          >
            {{ article.title }}
          </h3>
        </div>
        <div class="flex items-center">
          <UIcon
            name="i-tabler-arrow-right"
            class="w-5 h-5 text-gray-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all duration-500"
          />
        </div>
      </NuxtLink>
    </div>
    <hr class="my-8 md:my-16 border-t border-gray-200 dark:border-gray-700" />
  </div>
</template>
